import { render, staticRenderFns } from "./medication-popver.vue?vue&type=template&id=e1ed28e0&scoped=true&"
import script from "./medication-popver.vue?vue&type=script&lang=js&"
export * from "./medication-popver.vue?vue&type=script&lang=js&"
import style0 from "./medication-popver.vue?vue&type=style&index=0&id=e1ed28e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1ed28e0",
  null
  
)

export default component.exports